import { ICommandManager } from "~app/common/services/cqs/commandManager";
import { Utils } from "~app/common/services/utils";
import { Viol3DestineringRowViewModel } from "../arbetsorder-viol3-destineringsrader/arbetsorder-viol3-destineringsrader.component.models";
import {
    AddExtraInmatningshandelssortimentCommand,
    RemoveExtraInmatningshandelssortimentCommand
} from "../arbetsorder-viol3-destineringsrader/commands/AddExtraInmatningshandelssortimentCommand";
import { IArbetsorderRedovisningshanvisningDto } from "./IArbetsorderRedovisningshanvisningDto";
import { IRedovisningshanvisningDto } from "./IRedovisningshanvisningDto";
import { Viol3DestingeringstypDto } from "./IViol3DestineringDto";
import { IViol3DestineringsradDto } from "./IViol3DestineringsradDto";

export class Viol3DestineringViewModel {
    rows: Viol3DestineringRowViewModel[];
    typer: IViol3Destineringstyp[] = [];

    extrainmatningshandelssortiment: string[];
    extraInmatningshandelssortimentCommandState: string[];
    constructor(typer: Viol3DestingeringstypDto[], public extraInmatningshandelssortiment: string[], private readonly destineringId: number) {
        this.extraInmatningshandelssortimentCommandState = [...extraInmatningshandelssortiment];
        this.extrainmatningshandelssortiment = extraInmatningshandelssortiment;

        typer.forEach(t => {
            this.typer.push({
                typ: t.typ,
                inmatningshandelssortimentRedovisningshanvisningar: Viol3DestineringRowViewModel.create(t.inmatningshandelssortimentRedovisningshanvisningar),
                justeraTable: t.inmatningshandelssortimentRedovisningshanvisningar
                    .map(inm => ({
                        typ: t.typ,
                        inmatningshandelssortiment: inm.inmatningshandelssortiment,
                        arbetsorderRedovisningshanvisning: inm.arbetsorderRedovisningshanvisning,
                        applicableRedovisningshanvisningar: inm.applicableRedovisningshanvisningar,
                        redovisningshanvisning: inm.redovisningshanvisning,
                        viol3Destineringsrader: inm.viol3Destineringsrader
                    }))
            });
        });
    }

    processExtraInmatningshandelssortimentChanges(commandManager: ICommandManager) {
        const diffResult = Utils.diff(this.extraInmatningshandelssortimentCommandState, this.extrainmatningshandelssortiment, x => x, x => x);

        diffResult.adds.forEach(violId => {
            commandManager.updateCommand(new AddExtraInmatningshandelssortimentCommand(c => {
                c.violId = violId;
                c.destineringId = this.destineringId;
            }));
        });

        diffResult.removes.forEach(violId => {
            commandManager.updateCommand(new RemoveExtraInmatningshandelssortimentCommand(c => {
                c.violId = violId;
                c.destineringId = this.destineringId;
            }));
        });

        this.extraInmatningshandelssortimentCommandState = [...this.extrainmatningshandelssortiment];
    }
}

export interface IViol3Destineringstyp {
    typ?: string;
    inmatningshandelssortimentRedovisningshanvisningar: Viol3DestineringRowViewModel[];
    justeraTable: IViol3JusteraRow[];
}

export interface IViol3JusteraRow {
    inmatningshandelssortiment: string;
    typ?: string;
    arbetsorderRedovisningshanvisning: IArbetsorderRedovisningshanvisningDto;
    applicableRedovisningshanvisningar: IRedovisningshanvisningDto[];
    viol3Destineringsrader: IViol3DestineringsradDto[];
    redovisningshanvisning: IRedovisningshanvisningDto[];
}
